import { EEstimationTargets } from '@cian/valuation-main-filters-widget';

export function getButtonText(isMobile: boolean, estimationTarget: EEstimationTargets) {
  if (!isMobile) {
    return 'Оценить';
  }

  if (estimationTarget !== EEstimationTargets.flat) {
    return 'Оценить ЖК';
  }

  return 'Оценить квартиру';
}
